import React, { useEffect } from 'react';
import { Outlet, useLocation, useNavigationType } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';
import { OrganizationSchema, WebSiteSchema } from './StructuredData';

const Layout = () => {
  const { pathname, hash, state } = useLocation();
  const navigationType = useNavigationType();

  useEffect(() => {
    if (hash) {
      // Small timeout to allow DOM to render if navigating from another page
      setTimeout(() => {
        const id = hash.replace('#', '');
        const element = document.getElementById(id);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }, 100);
    } else if (navigationType === 'POP') {
      // Back/forward navigation — let browser handle scroll restoration
    } else if (state?.scrollY != null) {
      window.scrollTo(0, state.scrollY);
    } else {
      window.scrollTo(0, 0);
    }
  }, [pathname, hash, navigationType, state]);

  React.useEffect(() => {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
        }
      });
    }, { threshold: 0.1 });

    document.querySelectorAll('.animate-on-scroll').forEach(el => {
      observer.observe(el);
    });

    return () => observer.disconnect();
  }, [pathname]);

  return (
    <>
      {/* Site-wide Structured Data */}
      <OrganizationSchema />
      <WebSiteSchema />

      <Header />
      <main>
        <Outlet />
      </main>
      <Footer />
    </>
  );
};

export default Layout;
